import React from 'react';
import { Container } from 'react-bootstrap';
import { useStoreSettings } from '../contexts/StoreSettingsContext';
import 'quill/dist/quill.snow.css';
import '../components/Footer.css';

const ReturnPolicyPage = () => {
    const { settings } = useStoreSettings();

    return (
        <Container className="py-5">
            <h2 className="mb-4">Return Policy</h2>
            {settings.return_policy ? (
                <div
                    className="policy-content ql-editor"
                    dangerouslySetInnerHTML={{ __html: settings.return_policy }}
                />
            ) : (
                <p className="text-muted">Return policy is not configured yet.</p>
            )}
        </Container>
    );
};

export default ReturnPolicyPage;
